import { SmallText } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';
import styled from '@emotion/styled';

import IconCloseBlack from '@/assets/icons/icon-close-black.svg';

export const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  border: 1px solid ${colors.gray200};
  background: ${colors.white};
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.14);
  padding: 20px 12px;
  width: 375px;
`;

export const ModalTitle = styled.div<{ titleAlign?: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: ${(props) => props.titleAlign || 'none'};
  margin-bottom: 20px;

  .modal-title {
    font-weight: 700 !important;
  }
`;

export const IconClose = styled.i`
  position: absolute;
  right: 4px;
  background-image: url(${IconCloseBlack});
  background-repeat: no-repeat;
  background-position: center;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const ModalBody = styled.div``;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .modal-btn-container {
    display: flex;
    gap: 10px;
    margin-top: 40px;

    .btn-modal-footer {
      &.left {
        flex: 3;
      }

      &.right {
        flex: 7;
      }
    }
  }
`;

export const ModalFooterGuide = styled(SmallText)`
  letter-spacing: -0.15px;
  color: ${colors.gray600};
`;
